
import { ManagementWebhookRepository } from "@domain/management-webhook/repositories/management-webhook.repository";
import { ManagementWebhookRepositoryService } from "../repositories/management-webhook.service";

export const ManagementWebhookProvider = [
  {
    provide: ManagementWebhookRepository,
    useClass: ManagementWebhookRepositoryService,
  },
];